module.exports = __webpack_public_path__ + "static/media/perc-tribal.fa3edf57.wav";